export const MODAL_TYPE_WHO_LIKED_LIST = 'who-liked-list';
